'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _funnel = require('./funnel-v1/funnel.directive');

var _funnel2 = _interopRequireDefault(_funnel);

var _tabellen = require('./tabellen-v1/tabellen.directive');

var _tabellen2 = _interopRequireDefault(_tabellen);

var _welNietVerzekerd = require('./wel-niet-verzekerd-v1/wel-niet-verzekerd.directive');

var _welNietVerzekerd2 = _interopRequireDefault(_welNietVerzekerd);

var _heroDetail = require('./hero-detail-v1/hero-detail.directive');

var _heroDetail2 = _interopRequireDefault(_heroDetail);

var _heroDetail3 = require('./hero-detail-v2/hero-detail.directive');

var _heroDetail4 = _interopRequireDefault(_heroDetail3);

var _heroProduct = require('./hero-product-v1/hero-product.directive');

var _heroProduct2 = _interopRequireDefault(_heroProduct);

var _heroProduct3 = require('./hero-product-v2/hero-product.directive');

var _heroProduct4 = _interopRequireDefault(_heroProduct3);

var _heroHomepage = require('./hero-homepage-v1/hero-homepage.directive');

var _heroHomepage2 = _interopRequireDefault(_heroHomepage);

var _meerInformatie = require('./meer-informatie-v1/meer-informatie.directive');

var _meerInformatie2 = _interopRequireDefault(_meerInformatie);

var _inpageNavigatie = require('./inpage-navigatie-v1/inpage-navigatie.directive');

var _inpageNavigatie2 = _interopRequireDefault(_inpageNavigatie);

var _video = require('./video-v1/video.directive');

var _video2 = _interopRequireDefault(_video);

var _weetjes = require('./weetjes-v1/weetjes.directive');

var _weetjes2 = _interopRequireDefault(_weetjes);

var _actualiteiten = require('./actualiteiten-v1/actualiteiten.directive');

var _actualiteiten2 = _interopRequireDefault(_actualiteiten);

var _etalageV = require('./etalage-v1');

var _etalageV2 = _interopRequireDefault(_etalageV);

var _vergelijker = require('./vergelijker-v1/vergelijker.directive');

var _vergelijker2 = _interopRequireDefault(_vergelijker);

var _varianten = require('./varianten-v1/varianten.directive');

var _varianten2 = _interopRequireDefault(_varianten);

var _rendementVisualisatie = require('./rendement-visualisatie-v1/rendement-visualisatie.directive');

var _rendementVisualisatie2 = _interopRequireDefault(_rendementVisualisatie);

var _stappenplan = require('./stappenplan-v1/stappenplan.directive');

var _stappenplan2 = _interopRequireDefault(_stappenplan);

var _subnavigatie = require('./subnavigatie-v1/subnavigatie.directive');

var _subnavigatie2 = _interopRequireDefault(_subnavigatie);

var _coveo = require('./coveo-v1/coveo.directive');

var _coveo2 = _interopRequireDefault(_coveo);

var _coveoSitecore = require('./coveo-sitecore-v1/coveo-sitecore.directive');

var _coveoSitecore2 = _interopRequireDefault(_coveoSitecore);

var _dashboard = require('./dashboard-v1/dashboard.directive');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _contactV = require('./contact-v1');

var _contactV2 = _interopRequireDefault(_contactV);

var _klantbeoordelingReviewnavigator = require('./klantbeoordeling-reviewnavigator-v1/klantbeoordeling-reviewnavigator.directive');

var _klantbeoordelingReviewnavigator2 = _interopRequireDefault(_klantbeoordelingReviewnavigator);

var _klantbeoordelingSamenvatting = require('./klantbeoordeling-samenvatting-v1/klantbeoordeling-samenvatting.directive');

var _klantbeoordelingSamenvatting2 = _interopRequireDefault(_klantbeoordelingSamenvatting);

var _leadgeneratieV = require('./leadgeneratie-v1');

var _leadgeneratieV2 = _interopRequireDefault(_leadgeneratieV);

var _rbOnDemand = require('./rb-on-demand-v1/rb-on-demand.directive');

var _rbOnDemand2 = _interopRequireDefault(_rbOnDemand);

var _strip = require('./strip.directive');

var _strip2 = _interopRequireDefault(_strip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('cb.strips', [_welNietVerzekerd2.default.name, _heroDetail2.default.name, _heroDetail4.default.name, _heroProduct2.default.name, _heroProduct4.default.name, _heroHomepage2.default.name, _meerInformatie2.default.name, _funnel2.default.name, _tabellen2.default.name, _inpageNavigatie2.default.name, _video2.default.name, _weetjes2.default.name, _actualiteiten2.default.name, _etalageV2.default.name, _vergelijker2.default.name, _varianten2.default.name, _rendementVisualisatie2.default.name, _stappenplan2.default.name, _subnavigatie2.default.name, _coveo2.default.name, _coveoSitecore2.default.name, _dashboard2.default.name, _contactV2.default.name, _klantbeoordelingReviewnavigator2.default.name, _klantbeoordelingSamenvatting2.default.name, _leadgeneratieV2.default.name, _rbOnDemand2.default.name, _strip2.default.name]);

angular.module('cb').requires.push('cb.strips');

// Bootstrap the Angular application.  Note: this means that all Angular
// modules must be loaded by this point (i.e., strips.bundle.js should be the
// last script tag).
var useStrictDi = typeof window.environment !== 'undefined' && typeof window.environment.strictDi !== 'undefined' ? window.environment.strictDi : true;

angular.bootstrap(document, ['cb'], {
    strictDi: useStrictDi
});

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/strips/index.js
// module id = 428
// module chunks = 1